import React, {useState, useEffect} from 'react';
import axios from 'axios';
import { countDuplicatesItemArray, removeArrayDuplicates, removeItemArray } from '../../../utils/arrayFunc';
import { STORAGE_PRODUCTS_CART } from "../../../utils/constants";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { siteURL, woocomPart, consumerKey, consumerSecret } from '../../../utils/constants';
import Opciones from './Opciones';


export default function ContenidoCarritoCliente(props) {
    const { getProductsCart, productsCart } = props;
    const [productosCarrito, setProductosCarrito] = useState([]);
    const [singleProductsCart, setSingleProductsCart] = useState([])
    const [verDatos, setverDatos] = useState(false);
    const [cartTotalPrice, setCartTotalPrice] = useState(0); 
    const [itemCartWhap, setItemCartWhap] = useState([]);
    const [openNum, setOpenNum] = useState(false);


    const ClickOpenNum = () => {
      setOpenNum(true);
    };
    const CloseNum = () => {
      setOpenNum(false);
    };

    useEffect(() => {
      (async () => {
        await verCarrito();
        setverDatos(false);
      })();
      
  }, [verDatos]);
    useEffect(() => {
       const allProductsId = removeArrayDuplicates(productsCart);
        setSingleProductsCart(allProductsId);
        
  },[productsCart]);

  useEffect(() => {
    const productData = [];
    let totalPrice = 0;
    const arrayProductos = [];

    const allProdutsId = removeArrayDuplicates(productsCart);
    allProdutsId.forEach(productId=>{
        const quantity = countDuplicatesItemArray(productId, productsCart);
        const productValue ={
            id: productId,
            quantity: quantity,
        };
      productData.push(productValue);
    });
    if(verCarritoContenido){
      verCarritoContenido.map(product =>{
            productData.forEach(item =>{
                if(product.key == item.id){
                    const totalValue = product.precio * item.quantity;
                    totalPrice = totalPrice + totalValue
                }
            });
        });
        verCarritoContenido.map(product =>{
          productData.forEach(item =>{
              if(product.key == item.id){
                let productElementeWhat = {
                  id: product.key,
                  name: product.name,
                  cantidad: item.quantity,
                };
                arrayProductos.push(productElementeWhat);
              }
          });
          setItemCartWhap(arrayProductos);
      });

    }
    
    setCartTotalPrice(totalPrice);
    
}, [productsCart, productosCarrito])


    const emptyCart = () =>{
        localStorage.removeItem(STORAGE_PRODUCTS_CART);
        getProductsCart();
    }

    const increaseQuantity = (id) =>{
        const arrayItemsCart = productsCart;
        arrayItemsCart.push(id);
        localStorage.setItem(STORAGE_PRODUCTS_CART, arrayItemsCart);
        getProductsCart();
    };

    const decreaseQuantity = (id) =>{
        const arrayItemsCart = productsCart;
        const result = removeItemArray(arrayItemsCart, id.toString());
        localStorage.setItem(STORAGE_PRODUCTS_CART, result);
        getProductsCart();
    }

    const verCarrito = async () =>{
      if(singleProductsCart.length != 0){
        setverDatos(false);
      const productosParaCarrito = [];
        singleProductsCart.map(item =>{
        
            let link = `${siteURL}${woocomPart}products/${item}?consumer_key=${consumerKey}&consumer_secret=${consumerSecret}`;
            let config = {
                method: 'get',
                url: link,
                headers: { }
              };
              axios(config).then(function (response) {
                 return response.data
                }).then((item)=>{
                    let productElemente = {
                        img: item.images[0].src,
                        name: item.name,
                        key: item.id,
                        precio:  parseInt(item.price)
                      };
                     productosParaCarrito.push(productElemente);
                     return setProductosCarrito([productosParaCarrito]);
                })
                .catch(function (error) {
                console.log(error);
                return null;
            });
            
        });

      }else{
        setverDatos(true);
      }
        
        
    }
   
  
   
    const verCarritoContenido = productosCarrito[0];
   

  return (
    <div>
      {
      !verCarritoContenido
        ? "No hay Productos en el Carrito..."
        : singleProductsCart.map((idProductsCart,index) => {

            return (
              <CartContentProducts key={index}
                verCarritoContenido={verCarritoContenido} 
                idsProductsCart={productsCart} 
                idProductsCart={idProductsCart}
                increaseQuantity={increaseQuantity} 
                decreaseQuantity={decreaseQuantity}/>
            );
          })}

      <hr />
    <div className="text-left"><button className="btn btn-danger" onClick={ emptyCart }> Vaciar</button></div>
   
    <CartContentFooter cartTotalPrice={cartTotalPrice} itemCartWhap={itemCartWhap} ClickOpenNum={ClickOpenNum} openNum={openNum} CloseNum={CloseNum} />
    

    </div>
  );
}

function CartContentProducts(props){
  const {verCarritoContenido, idsProductsCart, idProductsCart, increaseQuantity, decreaseQuantity} = props;
  if(verCarritoContenido){
    return verCarritoContenido.map((product, index)=>{
      if(idProductsCart == product.key){
        const quantity = countDuplicatesItemArray(product.key, idsProductsCart);
        return(
          <RenderProduct 
          key={index}
          product={product}
          quantity={quantity}
          increaseQuantity={increaseQuantity}
          decreaseQuantity={decreaseQuantity}
          />
      );
      }
    })
  }
}

export function RenderProduct(props){
  const {product, quantity, increaseQuantity, decreaseQuantity} = props;
  return(
    <div
                id={product.key}
                className="card mb-3"
                style={{ maxWidth: "540px" }}
              >
                <div className="row no-gutters">
                  <div className="col-md-4">
                    <img src={product.img} className="card-img" alt="..." />
                  </div>
                  <div className="col-md-8">
                    <div className="card-body">
                      <h5 className="card-title">{product.name}</h5>
                      <div className="card-text">
                        Cantidad: {quantity}
                      </div>
                      <div className="card-text">
                        Precio: {product.precio} 
                      </div>
                    <div>
                        <button className="btn btn-primary" style={{"margin":"2px"}} onClick={()=>increaseQuantity(product.key)}>+</button>
                        <button className="btn btn-danger" style={{"margin":"2px"}} onClick={()=>decreaseQuantity(product.key)} >-</button>
                   </div>
                    </div>
                  </div>
                </div>
      </div>
  );
}



function CartContentFooter(props){
  const {cartTotalPrice, ClickOpenNum, openNum, CloseNum, itemCartWhap} = props;

  return(
    <div className="container" id="totales">
      <div className="text-right"><b>Total:</b>Q {cartTotalPrice.toFixed(2)}</div>

      <button target="_blank"
          className="btn btn-primary"
          onClick={ClickOpenNum}>
            Enviar a mi consultora de Belleza
      </button> 
      <Dialog
          open={openNum}
          onClose={CloseNum}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
        <DialogTitle id="alert-dialog-title">{"Enviar a Mi consultora de Belleza"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Opciones itemCartWhap={itemCartWhap} /> 
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={CloseNum} color="danger">
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>
    </div>
  )
}

